import React from 'react';
import styles from './style.module.scss';
import { classNames } from 'shared/utils/Helper';
import { useSelector } from 'react-redux';
export default function Heading({ heading, headingStyle }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return <h2 className={classNames(`${theme}FontBlackOne`, styles.heading, headingStyle ? headingStyle : '')}>{heading}</h2>;
}
